/* eslint-disable array-callback-return */
import React, { ChangeEvent, useEffect, useState } from 'react'
import { Col, FormGroup, Input } from 'reactstrap'
import { LI, UL } from '../../../AbstractElements'
import SvgIcon from '../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import SearchResult from './SearchResult'
import { SidebarItemType } from '../../../Types/LayoutTypes'
import { menuList } from '../../../Data/SidebarMenuList'
import { useLocation } from "react-router-dom";

export default function LeftHeader() {
    const [suggestion, setSuggestion] = useState<SidebarItemType[]>([]);
    const [searchValue, setSearchValue] = useState("");
    const location = useLocation();

    const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
        const searchKey = event.target.value.toLowerCase();
        setSearchValue(searchKey);
        if (searchKey !== "") {
            let icon: string | undefined;
            let suggestionArray: SidebarItemType[] = [];
            let updatedList: SidebarItemType = {};
            const deepSearchFun = (menuItem: any, searchKeyValue: string, mainTitle: string | undefined) => {
                if (menuItem.title.toLowerCase().includes(searchKeyValue) && menuItem.url) {
                    updatedList = { ...menuItem, mainTitle, icon };
                    suggestionArray.push(updatedList);
                }
                if (!menuItem.menu) return;
                menuItem.menu.forEach((mainSubItem: any) => {
                    if (menuItem.icon) {
                        icon = menuItem.icon;
                    }
                    deepSearchFun(mainSubItem, searchKeyValue, mainTitle);
                });
            };
            menuList.forEach((mainItem) => {
                mainItem.menu.forEach((data) => {
                    const mainTittle = data.title;
                    deepSearchFun(data, searchKey, mainTittle);
                });
            });
            setSuggestion(suggestionArray);
        } else {
            setSuggestion([]);
        }
    };

    useEffect(() => {
        setSearchValue("");
        setSuggestion([]);
    }, [location.pathname]);

    return (
        <Col xxl={5} xl={6} className="left-header col-auto box-col-4 horizontal-wrapper p-0">
            <div className="left-menu-header">
                <UL className="header-left simple-list">
                    <LI>
                        <FormGroup className="w-100 m-0">
                            <div className="Typeahead Typeahead--twitterUsers">
                                <div className="u-posRelative d-flex">
                                    <SvgIcon className='search-bg svg-color me-2' iconId='fill-search' />
                                    <Input value={searchValue} onChange={handleSearch} className="demo-input py-0 Typeahead-input form-control-plaintext w-100" type="text" placeholder="Search Oliva .." />
                                </div>
                                <SearchResult suggestion={suggestion} />
                            </div>
                        </FormGroup>
                    </LI>
                </UL>
            </div>
        </Col>
    )
}